const normalize = (url) => String(url || '').trim().replace(/\/+$/, '');

export const EDEFTER_API_URL = normalize(window.APP_CONFIG?.edefterApiUrl || 'https://srv.dpg.net.tr/edefter');
//export const EDEFTER_API_URL = normalize('http://localhost:9500');

